import { ReactNode } from "react";

interface SectionProps {
  children?: ReactNode;
}

const Section = ({ children }: SectionProps) => {
  return (
    <div className="border border-accent py-8 px-4 gap-2 mt-[-22px] md:mt-[-30px] flex flex-col">
      {children}
    </div>
  );
};

export { Section };
